<template>
  <v-menu
    v-model="isMenuOpen"
    offset-y
    left
    nudge-bottom="22"
    :close-on-content-click="false"
    :elevation="$vuetify.theme.dark ? 9 : 8"
    content-class="list-style notification-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :value="unreadCount > 0"
        :content="unreadCount > 99 ? '99+' : String(unreadCount)"
        color="error"
        overlap
      >
        <v-icon
          v-bind="attrs"
          v-on="on"
        >
          {{ icons.mdiBellOutline }}
        </v-icon>
      </v-badge>
    </template>
    <v-card class="app-bar-notification-content-container">
      <perfect-scrollbar
        class="ps-user-notifications"
        :options="perfectScrollbarOptions"
      >
        <v-list class="py-0">
          <!-- Header -->
          <v-list-item class="d-flex">
            <div class="d-flex align-center justify-space-between flex-grow-1">
              <span class="font-weight-semibold">{{ $t('Уведомления') }}</span>
              <v-chip
                v-if="unreadCount > 0"
                class="v-chip-light-bg primary--text font-weight-semibold"
                small
              >
                {{ unreadCount }}
              </v-chip>
            </div>
          </v-list-item>
          <v-divider></v-divider>

          <!-- Notifications -->
          <template v-for="(notification, index) in items">
            <v-list-item
              :key="'n' + notification.id"
              link
              @click="goToNews"
            >
              <v-list-item-avatar
                class="v-avatar-light-bg primary--text justify-center"
                size="30"
              >
                <v-icon color="primary">
                  {{ icons.mdiBellOutline }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content class="d-block">
                <v-list-item-title class="text-sm font-weight-semibold">
                  {{ notification.title }}
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <span class="text--secondary text-xs">{{ notification.date }}</span>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="index"></v-divider>
          </template>

          <v-list-item
            v-if="items.length === 0"
            key="no-news"
          >
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-center">
                {{ $t('Уведомлений пока нет') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            key="read-all-btn"
            class="read-all-btn-list-item"
          >
            <div class="flex-grow-1">
              <v-btn
                v-if="unreadCount > 0"
                block
                outlined
                small
                class="mb-2"
                @click="markAllRead"
              >
                {{ $t('Отметить все как прочитанные') }}
              </v-btn>
              <v-btn
                block
                color="primary"
                @click="goToNews"
              >
                {{ $t('Все новости') }}
              </v-btn>
            </div>
          </v-list-item>
        </v-list>
      </perfect-scrollbar>
    </v-card>
  </v-menu>
</template>

<script>
import store from '@/store'
import { ref } from '@vue/composition-api'
import { useRouter } from '@core/utils'
import { mdiBellOutline } from '@mdi/js'

// 3rd Party
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  components: {
    // 3rd Party
    PerfectScrollbar,
  },
  setup() {
    const { router } = useRouter()
    const isMenuOpen = ref(false)
    const unreadCount = ref(0)
    const items = ref([])

    store.dispatch('news/getNotifications').then(data => {
      unreadCount.value = data.unread_count || 0
      items.value = data.items || []
    })

    // ВАЖНО: простое открытие колокольчика больше НЕ помечает новости прочитанными.
    // Иначе модалка при входе переставала показываться, хотя новость ещё не читали.
    // Прочитанным помечает либо кнопка ниже, либо переход на страницу новостей.
    const markAllRead = () => {
      if (unreadCount.value === 0) return
      store.dispatch('news/disableNewsMark')
      unreadCount.value = 0
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      userData.news_mark = false
      localStorage.setItem('userData', JSON.stringify(userData))
    }

    const goToNews = () => {
      isMenuOpen.value = false
      if (router.currentRoute.name !== 'news') {
        router.push({ name: 'news' })
      }
    }

    const perfectScrollbarOptions = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      isMenuOpen,
      unreadCount,
      items,
      goToNews,
      markAllRead,
      perfectScrollbarOptions,

      icons: {
        mdiBellOutline,
      },
    }
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.app-bar-notification-content-container {
  .read-all-btn-list-item {
    padding-top: 14px;
    padding-bottom: 14px;
    min-height: unset;
  }
}

.ps-user-notifications {
  max-height: calc(var(--vh, 1vh) * 80);
}

.notification-menu-content {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    min-width: calc(100vw - (1.5rem * 2)) !important;
    left: 50% !important;
    transform: translateX(-50%);
  }
}
</style>
